// extracted by mini-css-extract-plugin
export default {"sortActionsWrapper":"LandscapeProjectsAddProjectsImpactIndicatorsOrganism_sortActionsWrapper__zQvty"};